import { style } from 'typestyle'
import { important } from 'csx'
export const primaryDarki = style({ color: important('#3979ca') })
